// import { NavLink } from 'react-router-dom';
import { Controller } from 'react-hook-form';
import {
  ListWithTitles,
  AutocompleteWithTitles,
  Autocomplete,
  // IconChangeLoClock,
} from '@ui/src';
import FeeBlock from './fee-form-block';
import FeeAttributes from './fee-attributes';
import useGetAutocompleteList from '../../store/dictionaries/helpers/use-accounts-autocomplete';
import { FeeTypes } from './types';

import cn from './tariffs.module.css';

const FeeForm = ({
  feeTypes,
  control,
  errors,
  feeType,
  feeId,
  writeOffType,
  isEditable,
  setValue,
  manualFee,
  regularFee,
  feeCascadeCurrenciesIds,
  feeCurrencyId,
  reset,
  clearErrors, // auditLogAvailable,
}: FeeTypes) => {
  const { accounts, onSearch } = useGetAutocompleteList(feeId);

  return (
    <div className={cn.feeForm}>
      <FeeBlock title="Fee type">
        <>
          <Controller
            control={control}
            name="feeId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <AutocompleteWithTitles
                name="type"
                placeholder="Select type..."
                title="Fee type"
                onChange={(e) => {
                  onChange(e.target.value);

                  feeTypes?.forEach((item) => {
                    const currentFee = item.list.find(
                      (listItem) => listItem.value === e.target.value,
                    );

                    if (currentFee) {
                      setValue('name', currentFee.name);
                    }
                  });
                }}
                tabIndex={feeId ? -1 : 0}
                value={value}
                error={errors?.feeId?.message}
                list={(feeTypes as ListWithTitles[]) || []}
                disabled={Boolean(feeId)}
                onClear={() =>
                  reset({
                    feeId: '',
                    name: '',
                    feeAmountType: '',
                  })
                }
                withClearButton
              />
            )}
          />
          <Controller
            control={control}
            name="name"
            defaultValue=""
            render={({ field: { name, value } }) => (
              <input type="hidden" value={value} name={name} />
            )}
          />
        </>
      </FeeBlock>
      <FeeBlock>
        <Controller
          control={control}
          name="feeTargetAccountNumber"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <>
              <Autocomplete
                name={name}
                title="Target account"
                placeholder="Select account..."
                value={value}
                onChange={onChange}
                list={accounts}
                onSearch={onSearch}
                disabled={Boolean(feeId && !isEditable)}
                fullWidth
                withSuffix
              />
              {errors?.feeTargetAccountNumber?.message && (
                <div className={cn.feeFormSelectErrorText}>
                  {errors?.feeTargetAccountNumber?.message}
                </div>
              )}
            </>
          )}
        />
      </FeeBlock>
      <FeeBlock title="Fee attributes">
        {!feeType ? (
          <div className={cn.createFeeAttributesHint}>
            First choose the fee type
          </div>
        ) : (
          <FeeAttributes
            control={control}
            errors={errors}
            writeOffType={writeOffType}
            isEditable={isEditable}
            manualFee={manualFee}
            feeId={feeId}
            regularFee={regularFee}
            feeCurrencyId={feeCurrencyId}
            feeCascadeCurrenciesIds={feeCascadeCurrenciesIds}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        )}
      </FeeBlock>
      {/* {auditLogAvailable && (
        <NavLink
          to={`/administration/change-logs?entityType=FEE&entityId=${feeId}`}
          target="_blank"
          className={cn.changeLogPanelLink}
        >
          <IconChangeLoClock />
          Change Log
        </NavLink>
      )} */}
    </div>
  );
};

export default FeeForm;
